import React, { Component } from 'react';
import './popup.scss';
import * as api from './../../api';
// 站内中奖弹窗
import InnerGetAward from './../../popup/innerGetAward';
// 站内未中奖弹窗
import InnerNoAward from './../../popup/innerNoAward';
// 站内分享弹窗
import InnerShare from './../../popup/innerShare';
// 站内活动已结束弹窗
import InnerEnded from './../../popup/innerEnded';
// 站内接口异常弹窗
import InnerError from './../../popup/innerError';
// 站外中奖弹窗
import OuterGetAward from './../../popup/outerGetAward';
// 站外未中奖弹窗
import OuterNoAward from './../../popup/outerNoAward';
// 站外分享弹窗
// import OuterShare from './../../popup/outerShare';
// 站外新人弹窗
import OuterNewUser from './../../popup/outerNewUser';
// 站外活动已结束弹窗
import OuterEnded from './../../popup/outerEnded';
// 风控用户弹窗
import RiskUserTip from './../../popup/riskUserTip';

import { Link } from 'react-router-dom';
import Detector from './../../utils/detector';

const isJrApp = navigator.userAgent.toLowerCase().match(/jdjr-app/i);
export default class Popup extends Component {
  constructor(props) {
    super (props)
    this.state = {
      isShow: false,
      status: 1,
      popupInfoDom: null,
      initInfoRes: {}
    }
    this.sharedWeixin = 'no'
  }

  componentWillMount() {
    this._judgeIsShareRemind()
  }

  _judgeIsShareRemind() {
    let param = {
      actCode: Detector.interface_ActCode
    }
    api.isFinishedInfo({reqData: JSON.stringify(param)}).then(res => {
      if(res.resultCode===-1) {
        this.setState({popupInfoDom: <InnerError/>})
        return
      }
      let { code, data } = res.resultData
      if (code === '00000hby') {
        sessionStorage.setItem('yqs_sharedWeixin_flag', data.weixin)
        this._judgeIsCanJoin(data.weixin)
      }
    })
  }

  _judgeIsCanJoin(str) {
    let info = JSON.parse(sessionStorage.getItem('yqs_initInfo_res'))
    console.log('sessionStorage_yqs_initInfo_res:::', info)
    let { resultCode, resultData } = info
    if (resultCode && resultCode === -1) {// 网关接口异常
      this.setState({popupInfoDom: <InnerError/>})
      return
    }
    this.setState({popupInfoDom: this._renderPopupByStatus(resultData.code, resultData.data, str), isShow: true})
  }
  
  // 开始游戏回调
  _handleJoin() {
    const {joinGameCallback} = this.props
    joinGameCallback({isJoin: true})
  }
 
  // 根据活动状态和站内外环境显示不同弹窗
  _renderPopupByStatus(code, data, isShare) {
    let {sysCode, isNewUser} = this.props
    let domObj = null
    if (sysCode === '-1') {
      this.setState({popupInfoDom: <InnerError/>})
      return
    }
    // let {gameAward} = this.state
    if (sysCode === '10001hby') {
      domObj = isJrApp ? <InnerEnded/> : <OuterEnded/>
      return domObj
    }
    console.log('props.sysCode_code:::', sysCode, code)
    if ((sysCode === '00000hby' || code === '00000hby') && isNewUser === '1') {
      domObj = <OuterNewUser joinGameCallback={(obj) => {this._handleJoin(obj)}}/>
      return domObj
    }
    if (sysCode === '10005hby' && isNewUser === '2') {
      domObj = <OuterGetAward/>
      return domObj
    }
    // 当前时间段可以抽奖
    if (data && sysCode !== '10004zt') {
      if (data.result === 'now') {
        if (isShare === 'no') { // 未分享弹分享弹窗
          domObj = isJrApp ? <InnerShare shareCallback={(obj) => this._ShareCallback(obj)} remindCallback={(obj) => this._RemindCallback(obj)}/> : <OuterGetAward/>
        } else {// 已分享弹中奖弹窗
          domObj = isJrApp ? <InnerGetAward shareCallback={(obj) => this._ShareCallback(obj)} remindCallback={(obj) => this._RemindCallback(obj)}/> : <OuterGetAward/>
        }
      } else if (data.result === 'next') {
        domObj = isJrApp ? <InnerNoAward/> : <OuterNoAward/>
      }  else if (data.result === 'noNext') {
        domObj = isJrApp ? <InnerEnded/> : <OuterEnded/>
      }
      return domObj
    }
    if (sysCode === '10004zt') { // 风控用户
      domObj = <RiskUserTip/>
      return domObj
    }
  }

  _handleCloseDialog(){
    console.log('_handleCloseDialog:::')
    window.$('body').find('.popup_dialog').css('display', 'none')
    window.$('body').find('.mask').css('display', 'none')
    setTimeout(() => {
      const {closeCallback} = this.props
      closeCallback({isShow: false})
    }, 500)
  }

  _ShareCallback(obj) {
    const info = window.data_source_100001226.activity.options;
    let shareMain = {img: `${info.share_icon_url}`, title: `${info.share_title}`, desc: `${info.share_summary}`}
    //channels: 0-微信朋友圈，1-微信好友
    let shareUrl = [
      {channels:'0',url: `${info.share_link}`},
      {channels:'1',url: `${info.share_link}`},
    ]
    window.GlobalShare.share(shareMain, shareUrl)
    let param = {
      actCode: Detector.interface_ActCode
    }
    api.isFinishedInfo({reqData: JSON.stringify(param)}).then(res => {
      let { code, data } = res.resultData
      if (code === '00000hby' && data.weixin === 'no') {
        setTimeout(() => {
          this._shareAddTimes.call(this)
        }, 2200);
      }
    })
  }

  _shareAddTimes() {
    let param = {
      actCode: Detector.interface_ActCode
    };
    api.addTimes({ reqData: JSON.stringify(param) }).then(res => {
      let {code} = res.resultData
      if (code === '00000hby') {
        this._setIsShared.call(this)
      }
    })
  }

  // 记录分享操作
  _setIsShared() {
    let param = {
      actCode: Detector.interface_ActCode,
      wxNickName: 'yes'
    }
    api.isFinishedInfo({reqData: JSON.stringify(param)}).then(res => {
      let { code } = res.resultData
      if (code === '00000hby') {
        console.log('增加抽奖次数成功')
        // 开始游戏回调
        // const {joinGameCallback} = this.props
        // joinGameCallback({isJoin: true})
      }
    })
  }

  _RemindCallback(obj) {
    let info = JSON.parse(sessionStorage.getItem('yqs_curGame_awardInfo'))
    let beginTime = '', endTime = ''
    if (typeof info.nextornow.nextTime === 'number') {
      // 提前5分钟提醒
      beginTime = info.nextornow.nextTime - 300000
      endTime = info.nextornow.nextTime + 300000
    } else { //返回noNext  活动已结束 没有下一场
      beginTime = info.nextornow.beginTime
      endTime = info.nextornow.endTime
    }
    let defer = window.jsBridgeV3.onReady()
    if (isJrApp) {
      try {
        defer.then(function(res) {
          res.jsToGetResp(function(d) {
            if (d.success === 0) {
              console.log('success')
            } else if (d.success === 1) {
              console.log('failed')
            }
          }, {
            "type": 36,
            "identifier": "摇钱树活动提醒：5分钟后别忘了抢红包" + (+new Date()), //事件唯一标示 （必须）
            "title": "摇钱树活动提醒：5分钟后别忘了抢红包~", //事件名称（必须）
            "startDate": beginTime, //开始时间 标准的时间戳
            "endDate": endTime,   //结束时间 标准的时间戳
            "allDay": "",   //是否是全天 （bool，非必须，默认为NO）
            "backUrl": "https://m.jr.jd.com/activity/yqshby2018/#/main"   //拓展url（非必须）
          })
        });
      } catch (error) {
        console.log('remind_error:::', error)
      }
      this._setIsRemind() // 标记已设置提醒
    }
  }

   // 记录设置提醒操作
   _setIsRemind() {
    let param = {
      actCode: Detector.interface_ActCode,
      code: 'yes'
    }
    api.isFinishedInfo({reqData: JSON.stringify(param)}).then(res => {
      let { code } = res.resultData
      if (code === '00000hby') {
        console.log('设置提醒操作成功:::')
      }
    })
  }

  componentWillUnmount() {
    window.removeEventListener('hashchange', (state) => {
      this.setState({popupInfoDom: null})
    })
  }

  render() {
    let { popupInfoDom } = this.state
    // <span className='btn_close' onClick={this._handleCloseDialog.bind(this)}></span>
    if (!popupInfoDom) return (<div></div>)
    return (
      <div className='mainWrap'>
        <div className='mask transparent'>
          {isJrApp ? <Link to='/main' className='btn_close' onClick={this._handleCloseDialog.bind(this)}></Link> : null}
        </div>
        <div className='popup_dialog'>
          <div className='popup_pic'></div>
          <div className='popup_bgColor'>
            <div className='water_bg'></div>
            {popupInfoDom}
          </div>
        </div>
      </div>
    )
  }
}